import React from 'react';
import {
  IconButton,
  Tooltip,
  Link as MuiLink,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Box,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { getPublicPageUrl } from '../../../utils/urlUtils';

function PageList({ pages = [], site, onEditPage, onDeletePage }) {
  if (!site) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>URL Slug</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pages.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No pages created yet. Click the 'Create New Page' button to add your first page.
              </TableCell>
            </TableRow>
          ) : (
            pages.map((page) => (
              <TableRow key={page.id}>
                <TableCell>{page.title}</TableCell>
                <TableCell>{page.slug}</TableCell>
                <TableCell>
                  {page.isPublished ? (
                    <Chip label="Published" color="success" size="small" />
                  ) : (
                    <Chip label="Draft" color="default" size="small" />
                  )}
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Preview page">
                    <IconButton
                      component={Link}
                      to={getPublicPageUrl(site.subdomain, page.slug)}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit page">
                    <IconButton
                      onClick={() => onEditPage(page)}
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete page">
                    <IconButton
                      onClick={() => onDeletePage(page)}
                      size="small"
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PageList; 